/**
 * ============================================================================
 *  AGENT D OWNS THIS FILE.
 * ============================================================================
 *
 * The C ↔ D seam (CONTRACT.md §3). Agent C created it as the handshake and will
 * not touch it again; it is the *only* file the router imports from
 * `screens/game/`, so real screens land here without editing anything in
 * `app/`, `net/` or `store/`.
 *
 * Every screen is rendered with **no props**: state comes from
 * `store/selectors.ts`, intents go out through `store/actions.ts`. By the time
 * a screen mounts the router has guaranteed the socket is connected, `snapshot`
 * is non-null, and the route matches the server's current phase.
 *
 * Sounds are handled centrally by the store (the lock chime on `lock_countdown`,
 * the sting on `reveal`), so screens do not fire them and cannot double them up.
 */
import type { GameScreenRegistry } from '../../app/gameScreens.js';
import { QuestionSelectScreen } from './QuestionSelectScreen.js';
import { RankAndPredictScreen } from './RankAndPredictScreen.js';
import { LockCountdownScreen } from './LockCountdownScreen.js';
import { RevealScreen } from './RevealScreen.js';
import { JustificationScreen } from './JustificationScreen.js';
import { RoundLeaderboardScreen } from './RoundLeaderboardScreen.js';
import { SuperlativesScreen } from './SuperlativesScreen.js';
import { EndedScreen } from './EndedScreen.js';

export const GAME_SCREENS: GameScreenRegistry = {
  'question-select': QuestionSelectScreen,
  'rank-and-predict': RankAndPredictScreen,
  'lock-countdown': LockCountdownScreen,
  reveal: RevealScreen,
  justification: JustificationScreen,
  'round-leaderboard': RoundLeaderboardScreen,
  superlatives: SuperlativesScreen,
  ended: EndedScreen,
};

export {
  QuestionSelectScreen,
  RankAndPredictScreen,
  LockCountdownScreen,
  RevealScreen,
  JustificationScreen,
  RoundLeaderboardScreen,
  SuperlativesScreen,
  EndedScreen,
};
